"use client"

import MuxPlayer from "@mux/mux-player-react"
import clsx from "clsx"
import type { CSSProperties } from "react"

type StreamType = "on-demand" | "live" | "ll-live" | "event"

interface Props {
    playbackId: string
    title: string
    posterUrl?: string | null
    className?: string
    streamType?: StreamType
    metadata?: {
        video_id?: string
        video_title?: string
        viewer_user_id?: string
    }
}

const baseStyle: CSSProperties = {
    width: "100%",
    border: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
}

/**
 * Renders the official Mux Player in audio-only mode while preserving
 * our layout styling through the parent container.
 */
export function PodcastMuxPlayer({
    playbackId,
    posterUrl,
    title,
    className,
    streamType = "on-demand",
    metadata,
}: Props) {
    return (
        <MuxPlayer
            playbackId={playbackId}
            audio
            streamType={streamType}
            poster={undefined}
            metadata={{
                video_id: playbackId,
                video_title: title,
                ...metadata,
            }}
            className={clsx("w-full text-black dark:text-white", className)}
            style={baseStyle}
            primaryColor="#015389"
            secondaryColor="#e5f0f7"
        />
    )
}
